<h3 translate class="page-title text-center">OPEN_CARTS</h3>
@if (openCartsListConfigService.parseFailCount > 0) {
  <div class="alert alert-warning mx-3">
    {{ openCartsListConfigService.parseFailCount }}
    {{ 'OPEN_CARTS_PARSE_FAILED' | translate }}
  </div>
}
<lib-filter-list [configService]="openCartsListConfigService"></lib-filter-list>